import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import { useAxiosWithAuthorization } from "../../../utils/api";
import useAppContext from "../../../utils/Reducers";
import ReactHlsPlayer from "react-hls-player";

const CameraRecordPop = ({ inspNo }) => {
  const [show, setShow] = useState(true);

  const [record, setRecord] = useState(null);
  const handleClose = (returnData) => {
    setShow(false);
  };

  //검수녹화 검색 URL
  const SERARCH_INSPECTION_RECORD_URL =
    "/inspection/video/searchInspectionRecordList.do";

  //const REPLAY_SERVER_URL = "http://localhost:7090/replay/";
  //const REPLAY_SERVER_URL = "http://192.168.70.43:8080/replay/";
  //const REPLAY_SERVER_URL = "http://imsrelay.idaehan.com:8080/replay/";
  //const REPLAY_SERVER_URL = "http://imsns.idaehan.com:8080/replay/";
  const REPLAY_SERVER_URL_NS = "https://imsns.idaehan.com:8443/replay/";
  const REPLAY_SERVER_URL_NRC = "https://imsrelaynrc.idaehan.com:8443/replay/";
  const REPLAY_SERVER_URL_GP = "https://imsrelaygp.idaehan.com:8443/replay/";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SERARCH_INSPECTION_RECORD_URL,
    },
    { manual: true }
  );

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    handleSearch();
  }, []);

  const handleSearch = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_INSPECTION_RECORD_URL,
      params: {
        inspNo: inspNo,
      },
    });

    setRecord(data);
  };

  const handleOk = (returnData) => {
    setShow(false);
  };

  return (
    <>
      <Modal show={show} onHide={() => handleClose(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title> 검수녹화 </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {record &&
            record.map((camera, index) => (
              <>
                <div className="searchdata">
                  <h2>{camera.cameraNm}</h2>
                  <ReactHlsPlayer
                    src={
                      (camera.scrapAreaCd.indexOf("1200N") >= 0
                        ? REPLAY_SERVER_URL_NRC
                        : camera.scrapAreaCd.indexOf("2100") >= 0
                        ? REPLAY_SERVER_URL_GP
                        : REPLAY_SERVER_URL_NS) +
                      camera.systemCd +
                      "/" +
                      inspNo +
                      "/" +
                      camera.cameraNm +
                      "/" +
                      inspNo
                    } // 플레이어 url
                    width="770px" // 플레이어 크기 (가로)
                    height="450px" // 플레이어 크기 (세로)
                    autoPlay={false} // 자동 재생 on
                    controls={true}
                  />
                </div>
              </>
            ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleOk(true)}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const ModalCameraRecordPop = createModal(CameraRecordPop);

export default CameraRecordPop;
